const BRANDS_ENUM = {};

document.addEventListener('DOMContentLoaded', () => {
    const initials = document.querySelector('.initials');
    const header = document.getElementById('shopify-section-header');
    const siteHeader = document.getElementById('SiteHeader');

    if (!initials || !header || !siteHeader) {
      return;
    }

    BRANDS_ENUM.initials = initials;
    BRANDS_ENUM.header = header;
    BRANDS_ENUM.siteHeader = siteHeader;

    initials.addEventListener('click', scrollToLetter, true);
    window.addEventListener('scroll', toggleStickinessToMenu);
    toggleStickinessToMenu();
});

function scrollToLetter(e) {
    const { initials, header } = BRANDS_ENUM;
    if (!e.target.classList.contains('brand-initial')) {
        return;
    }

    e.preventDefault();
    const letter = e.target.dataset.letter;
    const letterTitle = document.getElementById(letter);
    const headerHeight = parseInt(window.getComputedStyle(header).height);
    let scrollPoint;

    // if initials is not fixed, we need to add the initials height to the scroll point
    if (initials.classList.contains('initials-fixed')) {
        scrollPoint = letterTitle.offsetTop - headerHeight;
    } else {
        // add the initials height to the scroll point to compensate for the fixed initials
        // eslint-disable-next-line no-magic-numbers
        scrollPoint = letterTitle.offsetTop - headerHeight - 70;
    }
    window.scrollTo({top: scrollPoint, behavior: "smooth"});
}

function toggleStickinessToMenu() {
    const { initials, header, siteHeader } = BRANDS_ENUM;
    const headerStyle = window.getComputedStyle(header);
    const headerHeight = parseInt(headerStyle.height) - parseInt(headerStyle.paddingBottom);
    const initialsBorder = initials.offsetTop - headerHeight;

    if (window.scrollY > initialsBorder) {
        initials.classList.add('initials-fixed');
        initials.style.top = `${headerHeight}px`;
        siteHeader.classList.add('header-no-shadow');
        return;
    } 

    initials.classList.remove('initials-fixed');
    initials.style.top = 'unset';
    siteHeader.classList.remove('header-no-shadow');
}